import {
  IconBatterier,
  IconElektronik,
  IconGlasFargat,
  IconGlasOfargat,
  IconHushallsavfall,
  IconKontorspapper,
  IconLampor,
  IconLysror,
  IconMatavfall,
  IconMetall,
  IconPapperForpackningar,
  IconPlastForpackningar,
  IconSekretess,
  IconTonerKassetter,
  IconWellpappKartong,
} from 'assets/icons';

import { SEGMENT_TITLES } from './segmentCopy';

/** Segment-titlar från offertflödet — samma ordning som `SEGMENT_TITLES` / `preselectedForSegments` per material. */
export const MATERIAL_SEGMENT_KEYS: string[] = [
  ...SEGMENT_TITLES.filter((title) => title !== 'Annat'),
];

const Materials = [
  {
    icon: IconPapperForpackningar,
    type: 'Pappersförpackningar',
    preselectedForSegments: [...MATERIAL_SEGMENT_KEYS],
    details: [
      'Flingpaket',
      'Pappersmuggar, ursköljda',
      'Kartonger från färdigmat',
      'Mjölk- & juicepaket, ursköljda',
      'Papperspåsar',
      'Leksakskartonger',
      'Wellpappförpackningar',
    ],
  },
  {
    icon: IconPlastForpackningar,
    type: 'Plastförpackningar',
    preselectedForSegments: [...MATERIAL_SEGMENT_KEYS],
    details: [
      'Plastflaskor & dunkar',
      'Burkar & lock/korkar',
      'Plastfilm/folie',
      'Bärkassar & plastpåsar',
      'Chips- & godispåsar',
    ],
  },
  {
    icon: IconMetall,
    type: 'Metallförpackningar',
    preselectedForSegments: [...MATERIAL_SEGMENT_KEYS],
    details: ['Konservburkar', 'Kapsyler', 'Lock', 'Matförpackning av aluminium'],
  },
  {
    icon: IconKontorspapper,
    type: 'Kontorspapper',
    preselectedForSegments: ['Kontorsåtervinning'],
    details: [
      'Dator- och kopieringspapper',
      'Dags- och veckotidningar',
      'Reklam',
      'Broschyrer',
      'Kataloger',
      'Kuvert',
    ],
  },
  {
    icon: IconSekretess,
    type: 'Sekretesspapper',
    details: [
      'Konfidentiella dokument',
      'Handlingar som innehåller känslig information',
      'Offerter, fakturor, avtalsförslag, ritningar och lönelistor',
    ],
  },
  {
    icon: IconMatavfall,
    type: 'Matavfall',
    preselectedForSegments: ['Bostadsfastighet'],
    details: [
      'Frukt',
      'Grönsaker',
      'Matrester',
      'Bröd',
      'Kaffesump & filter',
      'Äggskal',
      'Hushållspapper',
    ],
  },
  {
    icon: IconWellpappKartong,
    type: 'Wellpapp',
    details: ['Wellpappförpackningar', 'Annan ren karton'],
  },
  {
    icon: IconPlastForpackningar,
    type: 'Mjukplast (LDPE)',
    details: ['Krymp & sträckfilm (LDPE)'],
  },
  {
    icon: IconGlasFargat,
    type: 'Färgade glasförpackningar',
    preselectedForSegments: ['Bostadsfastighet'],
    details: ['Färgade glasflaskor', 'Färgade glasburkar'],
  },
  {
    icon: IconGlasOfargat,
    type: 'Ofärgade glasförpackningar',
    preselectedForSegments: ['Bostadsfastighet'],
    details: ['Ofärgade glasflaskor', 'Ofärgade glasburkar'],
  },
  {
    icon: IconHushallsavfall,
    type: 'Restavfall',
    preselectedForSegments: ['Bostadsfastighet'],
    details: ['Sanitetsprodukter', 'Pennor', 'Disktrasor', 'Diskborstar', 'Snus', 'Ätpinnar'],
  },
  {
    icon: IconElektronik,
    type: 'Elektronik',
    details: [
      'Datorer',
      'Mikrovågsugn',
      'Brödrost',
      'Mobiltelefon',
      'Datorskärmar',
      'Enheter med batteri',
      'Enheter med sladd',
    ],
  },
  {
    icon: IconTonerKassetter,
    type: 'Toner & färgpatroner',
    details: ['Förbrukade bläck- och lasertoners från kopiatorer och skrivare'],
  },
  {
    icon: IconLampor,
    type: 'Ljuskällor',
    details: [
      'Glödlampor',
      'Halogenlampor',
      'Lågenergilampor',
      'LED-lampor',
      'Lysrör kortare än 60 cm',
    ],
  },
  {
    icon: IconLysror,
    type: 'Lysrör',
    details: ['Raka lysrör längre än 60 cm'],
  },
  {
    icon: IconBatterier,
    type: 'Småbatterier',
    details: [
      'Alla småbatterier inklusive små stavbatterier & knappcellsbatterier som innehåller litium',
    ],
  },
];

export default Materials;
